import { IncentiveCategory } from '@varo/graphql-schema-types';
import IncentiveErrorScreen from 'features/incentive/components/IncentiveErrorScreen/IncentiveErrorScreen';
import { IncentiveErrorSteps } from 'features/incentive/helpers/incentiveAnalytics';
import useIncentiveProgram from 'features/incentive/hooks/useIncentiveProgram';
import IncentiveNotAvailableScreen from 'features/incentive/screens/IncentiveNotAvailableScreen/IncentiveNotAvailableScreen';
import IncentiveUnsupportedContentScreen from 'features/incentive/screens/IncentiveUnsupportedContentScreen/IncentiveUnsupportedContentScreen';
import FullScreenLoading from 'shared/components/vxl/loading/FullScreenLoading/FullScreenLoading';

interface IncentiveProgramFallbackProps {
  incentiveType: IncentiveCategory;
  programResult: ReturnType<typeof useIncentiveProgram>;
}

function IncentiveProgramFallback({
  incentiveType,
  programResult: { program, fetching, error, incentivesError, refresh },
}: IncentiveProgramFallbackProps) {
  if (incentivesError || error) {
    return (
      <IncentiveErrorScreen
        incentiveType={incentiveType}
        errorStep={IncentiveErrorSteps.PROGRAM}
        errorCode={incentivesError?.code}
        title={incentivesError?.title}
        message={incentivesError?.message}
        isRetrying={fetching}
        onRetry={refresh}
      />
    );
  }

  if (!program) {
    return fetching ? (
      <FullScreenLoading />
    ) : (
      <IncentiveNotAvailableScreen incentiveType={incentiveType} />
    );
  }

  return <IncentiveUnsupportedContentScreen incentiveType={incentiveType} />;
}

export default IncentiveProgramFallback;
